module.exports = __webpack_public_path__ + "static/m-weber-94d3dfdd7aab8ee2ae665bbb2b12a844.png";